import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'
import { messages } from './i18n'
import './assets/css/main.css'

// Configuração do i18n para internacionalização
const i18n = createI18n({
  locale: 'pt-BR', // Idioma padrão
  fallbackLocale: 'pt-BR',
  messages,
  legacy: false
})

const app = createApp(App)

app.use(router)
app.use(i18n)

app.mount('#app') 